// extracted by mini-css-extract-plugin
export default {"card":"M5xh4S","videoCard":"w_JG4y","doubleImageWrapper":"TS2KVp","label":"ioPoAj","author":"hAr6Hx","image":"hdnuQh","singleImage":"mYB_nT"};